// tslint:disable
/* MACLE TypeScript 23/01/2026 00:31:27 */
import { ConsLojasComVendedorAPP } from '../vo/sitevo.vo';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { BaseService, AjaxService, IModelServiceResponse, Parser, ArrayList } from 'maf-web';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class LojaModelService extends BaseService {
  private _url = 'lojaService?action=';

  constructor(router: Router, ajax: AjaxService, private toastrService: ToastrService) {
    super(router, ajax, toastrService);
  }

  public getLojasComVendedor(): Promise<ConsLojasComVendedorAPP> {
    return this.ajax.get(this._url + 'getLojasComVendedor')
      .then((r: IModelServiceResponse<ConsLojasComVendedorAPP>) => Parser.jsonToClass(r.value, ConsLojasComVendedorAPP))
      .catch((error: any) => this.handleError(error));
  }

}


